import React, { useState, useEffect } from "react";
import {
  CardHeader,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { getResearchpaperApi, deleteResearchPaperApi } from "src/network/api";
import PageLayout from "./PageLayout";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import LoaderComponent from "./components/LoaderComponent";

const MyResearchPapers = () => {
  const [researchPaper, setResearchPaper] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedAbstract, setSelectedAbstract] = useState("");

  useEffect(() => {
    const fetchResearchPapers = async () => {
      try {
        setLoading(true);
        const response = await getResearchpaperApi();
        setResearchPaper(response.data || []);
      } catch (err) {
        setError("Failed to fetch research papers");
      } finally {
        setLoading(false);
      }
    };

    fetchResearchPapers();
  }, []);

  const handleDelete = async (id) => {
    const confirmAction = window.confirm(
      "Are you sure you want to delete this research paper?"
    );
    if (!confirmAction) return;
    try {
      const response = await deleteResearchPaperApi(id);
      if (response.status === 200 && response.data.status === 200) {
        setResearchPaper((prev) =>
          prev.filter((paper) => paper.paper_id !== id)
        );
        toast.success(response.data.message);
      } else {
        toast.error("Failed to delete research paper!");
      }
    } catch (e) {
      console.error(e);
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  const handleEdit = (id) => {
    navigate(`/update-research-paper/${id}`);
  };

  // Function to open modal and set selected abstract
  const handleModal = (abstract) => {
    setSelectedAbstract(abstract);
    setShowModal(true);
  };

  return (
    <PageLayout>
      <div className="container-fluid reviewer-table">
        <div className="research_paper-container">
          {/* Table Section */}
          <div className="table-container">
            <CardHeader className="bg-primary">
              <h3 className="mb-0 text-center font-weight-bold text-white">
                Research Paper List
              </h3>
            </CardHeader>

            {loading ? (
              <p>Loading research papers...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : researchPaper.length > 0 ? (
              <div className="table">
                <Table bordered hover responsive className="mb-0" size="sm">
                  <thead className="thead-light">
                    <tr>
                      <th>Paper Id</th>
                      <th>Paper Title</th>
                      <th>Subjects</th>
                      <th>Author Name</th>
                      <th>Author Contact</th>
                      <th>Author Email</th>
                      <th>Country</th>
                      <th>Affiliation</th>
                      <th>Abstract</th>
                      <th>Department</th>
                      <th>File</th>
                      <th>Keywords</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {researchPaper.map((researchpaper) => (
                      <tr key={researchpaper.paper_id}>
                        <td>{researchpaper.paper_id}</td>
                        <td>{researchpaper.paper_title}</td>
                        <td>{researchpaper.subjects}</td>
                        <td>{researchpaper.author_name}</td>
                        <td>{researchpaper.author_contact}</td>
                        <td>{researchpaper.author_email}</td>
                        <td>{researchpaper.country_name}</td>
                        <td>{researchpaper.affiliation}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => handleModal(researchpaper.abstract)}
                          >
                            View Abstract
                          </button>
                        </td>
                        <td>{researchpaper.department}</td>
                        <td>
                          <a
                            className="btn btn-xs btn-primary"
                            href={researchpaper.file}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa fa-download"></i>
                          </a>
                        </td>
                        <td>{researchpaper.keywords}</td>
                        <td>
                          <div className="d-flex justify-content-between w-100">
                            <Button
                              color="danger"
                              onClick={() =>
                                handleDelete(researchpaper.paper_id)
                              }
                            >
                              <FaTrashAlt />
                            </Button>
                            <Button
                              color="info"
                              onClick={() => handleEdit(researchpaper.paper_id)}
                              className="ml-2"
                            >
                              <FaEdit />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <p
                style={{
                  marginBottom: "80px",
                  marginTop: "80px",
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#6c757d",
                }}
              >
                No research paper found.
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Modal for Abstract */}
      <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
        <ModalHeader
          toggle={() => setShowModal(false)}
          close={
            <button className="close" onClick={() => setShowModal(false)}>
              &times;
            </button>
          }
        >
          Abstract
        </ModalHeader>
        <ModalBody>{selectedAbstract}</ModalBody>
      </Modal>
    </PageLayout>
  );
};

export default MyResearchPapers;
